import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { getIssue, updateIssueStatus } from 'actions/issues';
import IssueManagement from './IssueManagement';
import Sidebar from './Sidebar';
import { getSocketconnection } from '../../../helpers/socket';

function Issue(props) {
    const [issue, setIssue] = useState({});
    const issueRef = useRef(issue);

    React.useEffect(() => {
        // trigger capture any issue change (run on every rerender)
        // that prevent keeping old issues state 
        issueRef.current = issue;
    });

    useEffect(() => {
        async function getIssueData() {
            props.getIssue(props.routeParams.id);
        }

        getIssueData();
    }, []);

    const messageHandler = (message, issueCurrent) => {
        const {
            id, status, statusHistory, user, 
        } = message;

        if (issueCurrent._id === id) {
            setIssue({
                ...issueCurrent,
                status,
                statusHistory,
                statusBy: user,
            });
        }
    };

    useEffect(() => {
        const socket = getSocketconnection({ userId: props.user._id });

        const handler = message => messageHandler(message, issueRef.current);

        socket.on('admin:newIssueChanges', handler);
    }, []);


    useEffect(() => {
        setIssue(props.issue);
    }, [props.issue]);

    const handleChangeIssue = ({ _id, status }) => {
        props.updateIssueStatus(_id, status);
        setIssue({
            ...issue,
            status,
        });
    };
    
    return (
        <div className='issue-page'>
            <div className='content'>
                <IssueManagement issue={issue} handleChangeIssue={handleChangeIssue} />
            </div>
            <div className='sidebar'>
                <Sidebar issue={issue} user={props.user} />
            </div>
        </div>
    );
}

export default withRouter(connect(
    ({ issue, user: { user } }) => ({
        isLoaded: issue && issue.isLoaded,
        issue,
        user: _.pick(user, ['_id', 'email']),
    }),
    dispatch =>
        bindActionCreators(
            {
                getIssue,
                updateIssueStatus,
            },
            dispatch,
        ),
)(Issue));



// WEBPACK FOOTER //
// ./app/components/Issues/Issue/Issue.jsx